export { DeliveryTypeCard } from './delivery-type-card.component';
